import React from 'react'
import { useLocation } from 'react-router-dom'
import LoginMessage from 'components/common/login-message'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import styles from './index.module.css'
import { useTranslation } from '@disco/i18n/use-translation'

const InstructionsSent = (): React.ReactNode => {
  const { t } = useTranslation('accounts')
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const email = decodeURIComponent(searchParams.get('email') || '')
  const from = searchParams.get('from')
  let returnUrl = '/login'
  let returnMessage = t('accounts:backToSignIn', 'Back to Sign in')

  if (from === 'settings') {
    returnUrl = '/settings/security'
    returnMessage = t('accounts:backToSettings', 'Back to Settings')
  }

  return (
    <LoginMessage
      helmet={t('accounts:emailSent', 'Email Sent!')}
      title={t('accounts:emailSent', 'Email Sent!')}
    >
      <p className={styles.instructionsSentText}>
        {t(
          'accounts:emailHasBeenSentToEmailWithInstructionsOnResettingYourPassword',
          'Email has been sent to {{email}} with instructions on resetting your password.',
          { email },
        )}
      </p>
      <ButtonContainer centered>
        <Button link={returnUrl} appearance="primary" caption={returnMessage} />
      </ButtonContainer>
    </LoginMessage>
  )
}

export default InstructionsSent
